import { func } from 'prop-types';
import React, { useEffect } from 'react'

const FormStackContainer = ({ articleObj }) => {
    useEffect(() => {
        // console.log("FormStackContainer", articleObj);
        document.addEventListener("click", handleScroll);
        if (document.getElementById('formStackIframeId')) {
            // console.log("FormStackContainer",document.getElementById('formStackIframeId'));
            document.getElementById('formStackIframeId').contentWindow.location.reload();
            document.getElementById('formStackIframeId').onload = resizeIframe;
        }
       document.onclick=handleScroll;
    }, [])
    const resizeIframe = () => {
        const iframe = document.getElementById('formStackIframeId');
        // console.log("FormStackContainer resizeIframe",iframe);
        if (iframe && iframe.contentWindow) {
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
            // console.log("FormStackContainer body",iframe.contentWindow.document.body);
        }
        
        iframe.contentWindow.document.body.addEventListener('click', function(event) {
            setTimeout(() => {
            let documentHeight = Math.max(iframe.contentWindow.document.body.offsetHeight);
            
           
          if (iframe && iframe.contentWindow) {
              iframe.style.height = documentHeight + 'px';
          }
          
            }, 500);
            
          })
          
    }
   

    function handleScroll(){
        const iframe = document.getElementById('formStackIframeId');
        
        if (iframe && iframe.contentWindow) {
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
            
        }
          
    }
    return (
    <div onClick={()=>handleScroll()}>
        {articleObj?.attributes?.formStackUrl ?
            <iframe width="100%" id="formStackIframeId" src={`/formStack?formStackurl=${articleObj?.attributes?.formStackUrl}`} scrolling="no"/>
            : ""}
    </div>

    )
}

export default FormStackContainer